import { render, staticRenderFns } from "./stuBasic.vue?vue&type=template&id=10b0507e"
import script from "./stuBasic.vue?vue&type=script&lang=js"
export * from "./stuBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports